import { useIsKzCompany } from '@shared/lib/use-is-kz';

export function CartSelfDeliveryData() {
  // Для казахстанских клиентов самовывоз — со склада в Алматы,
  // казанский адрес им не подходит. Страну определяем по валюте
  // корзины (см. useIsKzCompany).
  const isKz = useIsKzCompany();

  return (
    <div className="flex gap-20">
      <div className="flex-1">
        <h3 className="text-base font-semibold text-gray-900 mb-5">
          Адрес офиса:
        </h3>
        <div className="mb-3">
          {isKz ? (
            <p className="text-base font-medium text-gray-900 leading-relaxed">
              Казахстан, г. Алматы, Ауэзовский район,
              <br />
              микрорайон Сайран, дом 6А
            </p>
          ) : (
            <p className="text-base font-medium text-gray-900 leading-relaxed">
              Республика Татарстан, г. Казань,
              <br />
              ул. Дементьева, 2Б корпус 4
            </p>
          )}
        </div>
        <p className="text-base text-gray-900 leading-relaxed">
          Пн-Пт: 08:00 – 17:00
          <br />
          Сб-Вс: Выходные
        </p>
      </div>

      <div className="flex-1">
        <h3 className="text-base font-semibold text-gray-900 mb-5">
          Контактная информация:
        </h3>
        {!isKz && (
          <div className="mb-3">
            <p className="text-base font-medium text-gray-900">8 800 777 16 03</p>
            <p className="text-base text-gray-900">
              Для звонков из России – бесплатно
            </p>
          </div>
        )}
        <div>
          <p className="text-base font-medium text-gray-900">8 495 108 68 33</p>
          <p className="text-base text-gray-900">
            Для звонков из СНГ и других стран
          </p>
        </div>
      </div>
    </div>
  );
}
